import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';

import App from './components/App';
import Firebase, { FirebaseContext } from './components/Firebase';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrash, faKey, faArrowAltCircleUp, faAlignJustify, faCalendarAlt,
    faSignOutAlt, faPencilAlt, faEuroSign, faCalendarDay, faLayerGroup } from '@fortawesome/free-solid-svg-icons';

ReactDOM.render(
    <FirebaseContext.Provider value={new Firebase()}>
        <App />
    </FirebaseContext.Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();

library.add(faTrash, faKey, faArrowAltCircleUp, faAlignJustify, faCalendarAlt,
    faSignOutAlt, faPencilAlt, faEuroSign, faCalendarDay, faLayerGroup);

